module.exports = __webpack_public_path__ + "static/media/santander.2aa63a46.png";